const f = {
  gray: {
    base: {
      10: "#f9f8f7",
      20: "#f2f2f2",
      30: "#e5e5e5",
      40: "#d0d0d0",
      50: "#d8d8d8",
      60: "#9b98aa",
      70: "#767676",
      80: "#49565d",
      90: "#4d4d4d",
      100: "#2f3c44",
      110: "#333333"
    }
  },
  brand: {
    base: {
      0: "#f7f7fe",
      5: "#f9f9fe",
      10: { default: "#f0f3f7", opac85: "#f0f3f7d8" },
      20: "#f3f3fd",
      30: "#e7e7f6",
      40: "#e1e2ff",
      50: "#d1d2ec",
      60: "#b6b9f3",
      65: "#aeb1f2",
      70: "#676dfd",
      80: { default: "#5e63e5", opac40: "#5e63e566" },
      90: "#393eb7"
    }
  },
  blue: {
    base: {
      5: "#e2ecf5",
      10: "#d4dee7",
      20: "#b0cce4",
      25: "#abcbe2",
      30: {
        default: "#6fa2ce",
        opac20: "#6fa2ce33",
        opac40: "#6fa2ce66"
      },
      35: { default: "#5e9bc8", opac40: "#5e9bc866" },
      40: "#40729d"
    }
  },
  green: {
    base: {
      5: "#f2f9f2",
      10: "#cfe0df",
      15: "#ddefed",
      20: "#a2d4cf",
      25: "#74cdc4",
      30: {
        default: "#55b1a7",
        opac20: "#55b1a733",
        opac40: "#55b1a766"
      },
      35: { default: "#3aa197", opac40: "#3aa19766" },
      40: "#388b82",
      45: "#81c580",
      50: "#58c900",
      60: "#1da865",
      70: "#028a00"
    }
  },
  orange: {
    base: {
      5: "#fffaf7",
      10: "#f1e3d1",
      15: { default: "#fff2df", opac70: "#fff2dfC7" },
      20: "#ffd89e",
      30: { default: "#ffbe5e", opac20: "#ffbe5e33", opac40: "#ffbe5e66" },
      40: "#ffb800",
      50: "#ff8717",
      60: "#fda467",
      70: "#c98726",
      80: "#e4894a"
    }
  },
  olive: {
    base: {
      10: "#cecec9",
      20: "#acada0",
      30: { default: "#4e5136", opac40: "#4e513666" },
      40: "#333620"
    }
  },
  brown: {
    base: {
      10: "#e9dfd8",
      15: "#e8d9d0",
      20: "#e0cfc3",
      25: "#e8d6c4",
      30: "#e6ccb3",
      35: "#dabc9f",
      40: { default: "#d6ac84", opac40: "#d6ac8466" },
      45: "#c49b84",
      50: "#ae7e50",
      55: "#be8955",
      60: "#d7a98f",
      70: { default: "#b05420", opac40: "#b0542066" },
      80: "#8e3f12"
    }
  },
  red: {
    base: {
      10: "#ff3737",
      20: "#da2727",
      30: "#c8374f",
      40: "#b00020"
    }
  },
  pink: {
    base: {
      5: "#fbf2f4",
      10: "#eecfd5",
      15: "#fcdde3",
      20: "#f7abb8",
      25: "#d7808f",
      30: { default: "#ef5771", opac20: "#ef577133", opac40: "#ef577166" },
      40: "#e473ee"
    }
  },
  purple: {
    base: {
      10: "#eec9ee",
      20: "#e2a2e2",
      30: { default: "#c953c9", opac40: "#c953c966" },
      40: "#b238b2"
    }
  },
  neutral: {
    white: { default: "#ffffff", opac75: "#ffffffbf" },
    black: {
      opac10: "#0000001a",
      opac15: "#00000026",
      opac25: "#00000040",
      opac45: "#00000073"
    }
  }
};
export {
  f as COLOR_PRIMITIVES
};
//# sourceMappingURL=index.es648.js.map
